export default __webpack_public_path__ + "static/media/GIN.a3572337.jpg";